<!--
 * @Description: 函询弹框里的文件上传
-->
<template>
  <div class="upload-paper">
    <UploadBtn
      v-if="isUpload"
      @change="addfile"
      :limit="5"
      :fileSize="10"
      :fileList="fileList"
      ref="AliOssUpload"
    ></UploadBtn>
    <div
      style="margin:-12px 0 25px 0;font-size:12px;color:#969696;height:12px"
    >
      支持扩展名：.doc .docx .pdf .jpg，最多上传5个文件，每个大小不超过10Mb
    </div>
    <!-- 附件展示信息的卡片 -->
    <template>
      <div v-if="fileList && fileList.length" class="attachmenCard">
        <template v-for="(item, index) in fileList">
          <div class="file-item-container" :key="index">
            <img
              :src="fileIcon[item.name.split('.').pop().toLowerCase()]"
              alt=""
              class="file-icon"
            />
            <div class="file-info">
              <div class="file-name">
                <div class="fore">
                  {{ item.name.slice(0, item.name.lastIndexOf(".")) }}
                </div>
                <div class="back">.{{ item.name.split(".").pop() }}</div>
              </div>
              <div class="file-other">
                <span class="file-size">{{ formatFileSize(item.size) }}</span>
                <span>
                  <span v-if="isUpload" class="file-status">上传完成</span>
                  <span
                    class="file-see"
                    @click='$previewFile(item.fileUrl,item.name)'
                    >预览</span
                  >
                </span>
              </div>
              <div class='delBtn' @click='handleFile(item, index)'>
                <img src="@/assets/public/tips-err.png" alt="">
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import "@/utils/previewFile"
export default {
  name: "UploadAttachments",
  components: {
    UploadBtn: () => import("@/components/public/uploadFiles/UploadBtn.vue") //文件上传组件
  },
  data() {
    return {
      //附件图标
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png"),
      },
    };
  },
  props: {
    //附件列表
    fileList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    //判断是上传还是展示预览(不传默认是上传)
    isUpload: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    //计算附件大小
    formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize);
      if (fileSize / 1024 > 10) {
        return `${(fileSize / 1024).toFixed(2)}M`;
      } else {
        return `${Math.ceil(fileSize)}kb`;
      }
    },
    //判断是删除还是预览
    handleFile(item, index) {
      if (this.isUpload) {
        this.fileList.splice(index, 1);
        this.$emit("changeAttachment", this.fileList); //通知父组件修改
      } 
    },
    //子组件触发change事件
    addfile(val, objdetail) {
      if(this.fileList.length==5){
        this.$message.error(`最多上传5个文件`);
        return
      }
      //上传附件
      if (objdetail.status && objdetail.status == "success") {
        let { ...filesObj } = objdetail.filesObj;
          this.fileList.push({
            name: filesObj.name,
            fileUrl: filesObj.fileUrl,
            size: filesObj.fileSize,
            suffix: filesObj.fileType,
          });
          this.$emit("changeAttachment", this.fileList); //通知父组件修改
        }
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.upload-paper {
  padding-right: 10px;
  .icon-delete {
    margin-left: 10px;
    font-size: 14px;
    color: #FF6600;
  }
  .destext {
    font-size: 12px;
    line-height: 20px;
    color: #969696;
    margin-top: 2px;
  }
  .attachmenCard {
    display: flex;
    flex-wrap: wrap;
    .file-item-container {
      position: relative;
      width: 206px;
      height: 38px;
      display: flex;
      background: #fafafa;
      border-radius: 4px;
      margin-right: 20px;
      margin-bottom: 10px;
      padding: 10px 20px 12px 10px;
      font-size: 14px;
      .file-icon {
        width: 33px;
        height: 40px;
      }
      .file-info {
        flex: 1;
        padding-left: 10px;
        line-height: 1.2;
        .file-name {
          max-width: 165px;
          margin-bottom: 8px;
          display: flex;
          color: #333333;
          .back {
            text-align: left;
            flex-shrink: 0;
            // width: 36px !important;
          }
          .fore {
            max-width: 158px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
        }
        .file-other {
          display: flex;
          justify-content: space-between;
          .file-size {
            color: #969696;
          }
          .file-status {
            color: #78C06E;
          }
          .file-see {
            margin-left: 10px;
            cursor: pointer;
            color: #0286df;
          }
        }
      }
      .delBtn {
        position: absolute;
        top: -7px;
        right: -8px;
        cursor: pointer;
        img {
          width:16px;
          height:16px
        }
      }
    }
  }
}
</style>